var _path, _path2, _path3, _path4, _path5, _path6, _path7, _g, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWinnere996E91C(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 406,
    height: 306,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.24,
    d: "M357.008 268.68c19.059-11.528 32.283-31.266 35.51-52.496 3.227-21.231-3.513-43.593-17.823-60.195-15.735-18.26-39.34-29.094-55.565-46.97-24.02-26.456-29.479-65.592-56.447-89.341-18.306-16.142-45.108-22.701-69.702-18.374-24.593 4.328-46.615 19.015-60.608 38.7-19.836 27.963-23.817 64.589-46.45 90.57-10.473 12.018-24.285 20.937-36.19 31.665C22.72 186.478 5.38 223.602 15.71 257.484c2.405 7.901 6.333 15.561 12.522 21.329 11.536 10.744 28.793 13.352 44.882 14.83 55.332 5.074 111.078 3.189 166.62 1.297 12.244-.415 23.447-1.606 34.764-6.311 9.485-3.935 17.853-9.462 28.484-9.884 20.07-.799 35.714 1.01 54.027-10.065z",
    fill: "rgb(56 120 244 )"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M254.397 171.045a8.647 8.647 0 00.664 5.157 2.333 2.333 0 001.847 1.372 3.012 3.012 0 001.794-.889 2.6 2.6 0 001.199-2.933c-.324-3.016-.626-6.137.264-9.047.146-.34.183-.717.106-1.078-.506-1.403-3.461-.189-4.087.565-1.251 1.553-1.575 4.938-1.787 6.853z",
    fill: "rgb(56 120 244 )"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M254.397 171.045a8.647 8.647 0 00.664 5.157 2.333 2.333 0 001.847 1.372 3.012 3.012 0 001.794-.889 2.6 2.6 0 001.199-2.933c-.324-3.016-.626-6.137.264-9.047.146-.34.183-.717.106-1.078-.506-1.403-3.461-.189-4.087.565-1.251 1.553-1.575 4.938-1.787 6.853z",
    fill: "url(#prefix__paint0_linear_15788_47143)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M277.211 257.823c10.495-12.311 10.661-30.067 10.857-46.246.083-6.378 1.183-14.182 7.132-16.496 3.596-1.395 7.901 0 10.51 2.865 2.608 2.865 3.679 6.853 3.611 10.713-.06 3.099-.754 6.175-.603 9.274.641 10.909 11.799 18.049 15.946 28.159 2.917 7.125 2.05 15.524-1.614 22.302-3.664 6.778-9.929 11.95-16.986 15.033-5.745 2.511-12.417 3.687-18.305 1.508-5.889-2.179-10.51-8.399-9.372-14.566",
    fill: "rgb(56 120 244 )"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M277.211 257.823c10.495-12.311 10.661-30.067 10.857-46.246.083-6.378 1.183-14.182 7.132-16.496 3.596-1.395 7.901 0 10.51 2.865 2.608 2.865 3.679 6.853 3.611 10.713-.06 3.099-.754 6.175-.603 9.274.641 10.909 11.799 18.049 15.946 28.159 2.917 7.125 2.05 15.524-1.614 22.302-3.664 6.778-9.929 11.95-16.986 15.033-5.745 2.511-12.417 3.687-18.305 1.508-5.889-2.179-10.51-8.399-9.372-14.566",
    fill: "url(#prefix__paint1_linear_15788_47143)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M322.083 220.572c.316-2.911.354-5.949 1.666-8.558a9.496 9.496 0 018.253-5.24 9.501 9.501 0 018.507 4.818c3.355 5.926-.309 13.134-2.496 19.603a44.06 44.06 0 00-.671 25.943c1.463 5.172 3.891 10.555 2.209 15.689-1.756 5.33-7.939 8.436-13.503 7.645-5.564-.792-10.283-4.833-12.997-9.749-4.057-7.366-5.572-15.636-1.508-22.889 4.78-8.655 9.446-17.288 10.54-27.262z",
    fill: "rgb(56 120 244 )"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M322.083 220.572c.316-2.911.354-5.949 1.666-8.558a9.496 9.496 0 018.253-5.24 9.501 9.501 0 018.507 4.818c3.355 5.926-.309 13.134-2.496 19.603a44.06 44.06 0 00-.671 25.943c1.463 5.172 3.891 10.555 2.209 15.689-1.756 5.33-7.939 8.436-13.503 7.645-5.564-.792-10.283-4.833-12.997-9.749-4.057-7.366-5.572-15.636-1.508-22.889 4.78-8.655 9.446-17.288 10.54-27.262z",
    fill: "url(#prefix__paint2_linear_15788_47143)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.24,
    fill: "rgb(56 120 244 )"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M265.133 71.051a12.955 12.955 0 01-2.262 4.674c.401.51.856.975 1.357 1.388.103.1.235.166.377.188a.757.757 0 00.483-.21l5.149-3.99a.612.612 0 00.256-.293c.106-.287-.188-.558-.452-.754a7.64 7.64 0 00-2.933-1.327 2.6 2.6 0 00-2.752 1.266M271.571 87.713a18.975 18.975 0 00-5.662-2.616 3.427 3.427 0 00-2.677.06c-1.176.709-1.184 2.533-.377 3.65.807 1.115 2.156 1.673 3.423 2.193a1.982 1.982 0 002.955-.618l2.405-3.069M271.518 79.51a.41.41 0 00-.242.151.42.42 0 000 .271l.324 1.267c.01.064.042.123.091.166a.256.256 0 00.151 0l3.641-.136c.189 0 .317-1.508.287-1.681-.106-.618-.061-.588-.664-.679a9.088 9.088 0 00-3.588.641zM258.957 69.905a7.89 7.89 0 00-2.261.754c-.206.079-.38.222-.498.407a.753.753 0 00.354.897c.333.14.705.156 1.048.046a1.837 1.837 0 001.191-.845 1.001 1.001 0 00-.331-1.312M264.017 66.904a3.72 3.72 0 00-2.345-1.146.594.594 0 00-.324 0 .476.476 0 00-.166.618c.121.207.295.376.505.49.346.273.774.419 1.214.415.437-.06.814-.565.596-.942M272.325 66.663h-2.767c-.339 0-.754.06-.867.377-.113.317.211.648.55.694.335.012.67-.037.988-.144a3.067 3.067 0 011.628.106.945.945 0 00.649.09c.399-.165.279-.754.09-1.153M275.588 99.64l-1.47 1.071a3.552 3.552 0 00-1.244 1.281 1.23 1.23 0 00.392 1.591c.701.362 1.508-.309 1.855-1.018.346-.708.58-1.545 1.251-1.952.264-.159.588-.241.754-.498a.813.813 0 00-.377-1.063 2.299 2.299 0 00-1.221-.188M249.834 98.05c-.468-.272-1.101-.536-1.508-.159-.407.377.053 1.282.686 1.448.633.166 1.304 0 1.945.09a2.436 2.436 0 00-.339-1.96M191.282 82.013a43.185 43.185 0 01-3.408-7.192l-2.722 3.015a1.342 1.342 0 00-.437.822c.033.307.168.594.384.814l2.36 2.926c.633.791 1.365 1.636 2.368 1.771 1.002.136 2.118-.972 1.575-1.832M193.189 54.344l-4.705 4.071c.121 1.236 1.946 1.221 3.092.754 1-.308 1.864-.95 2.45-1.817.482-.92.128-2.322-.89-2.54M168.094 64.952c.241 1.16-.128 2.382.06 3.558.189 1.176 1.402 2.375 2.45 1.81a2.21 2.21 0 00.928-1.757 9.488 9.488 0 00-.619-4.863M140.014 110.512a24.606 24.606 0 01-7.223 5.775c-.535.279-1.138.626-1.228 1.222a1.908 1.908 0 00.618 1.409l2.216 2.639a1.182 1.182 0 00.912.611 1.172 1.172 0 001.018-.407 123.716 123.716 0 004.584-3.303 5.85 5.85 0 001.757-1.794c.754-1.38.279-3.159-.701-4.388a12.211 12.211 0 00-3.77-2.774M149.304 122.175a5.446 5.446 0 01-.189 3.016 4.195 4.195 0 00.053 3.016c.49.905 1.96 1.267 2.526.407.49-1.855.98-3.89.196-5.647-.784-1.757-3.423-2.722-4.66-1.244M290.147 136.681c-.362 1.825.076 4.396 1.93 4.524 1.991.113 2.466-3.182.89-4.411-1.576-1.229-3.808-.912-5.768-.55M300.987 124.95a15.368 15.368 0 00-7.072.867c-.068 2.88 3.641 5.051 6.122 3.589l.173-4.524M131.604 208.071a18.722 18.722 0 00-14.009-6.318 9.674 9.674 0 00-.678 6.16 27.01 27.01 0 019.643 4.524l3.634-5.926M156.021 192.08a27.336 27.336 0 00-9.364-.354 3.61 3.61 0 00.754 3.943 5.143 5.143 0 006.325-1.817 5.732 5.732 0 00-.52-6.687M123.927 146.784a73.542 73.542 0 00-12.44-12.402 21.33 21.33 0 00-.852 9.929 1072.37 1072.37 0 0011.95 5.964M289.8 90.201a4.467 4.467 0 00-.754-1.598 1.509 1.509 0 00-1.568-.566 1.505 1.505 0 00-.897 1.47c.048.612.22 1.207.505 1.75a1.697 1.697 0 00-1.855 1.206 1.63 1.63 0 001.086 1.907 1.575 1.575 0 001.885-1.1 1.083 1.083 0 00.2 1.031 1.083 1.083 0 00.984.37 1.243 1.243 0 00.845-1.299 1.256 1.256 0 00-.174-.525 1.063 1.063 0 10.927-1.507 1.159 1.159 0 001.036-.715 1.165 1.165 0 00-.224-1.239 1.156 1.156 0 00-1.221-.307 1.162 1.162 0 00-.782.986M128.667 135.972c-1.025-.346-2.36-.603-3.016.249a1.968 1.968 0 00-.286 1.508 2.718 2.718 0 001.508 2.164 1.777 1.777 0 002.314-.882c.033.785.228 1.555.573 2.262a1.9 1.9 0 001.991.98 2.06 2.06 0 001.07-.822c.701-.973.754-2.624-.339-3.106.824.302 1.714.38 2.578.226a1.687 1.687 0 001.55-1.806 1.685 1.685 0 00-1.806-1.549 5.557 5.557 0 00-2.405.437 4.532 4.532 0 00-.264-3.513 1.348 1.348 0 00-.475-.551c-.49-.271-1.093.083-1.508.49a4.765 4.765 0 00-1.259 3.823M121.485 98.796a5.623 5.623 0 00-.384-2.654 1.948 1.948 0 00-2.224-1.1 2.82 2.82 0 00-1.327 1.44 4.474 4.474 0 00-.754 2.367c.06.844.754 1.688 1.613 1.56a7.295 7.295 0 00-2.329 4.644 1.254 1.254 0 00.256 1.064 1.152 1.152 0 001.01.15 3.852 3.852 0 002.933-3.996c.294.973.897 2.172 1.908 2.051.274-.063.529-.193.74-.379.212-.185.375-.42.473-.684a3.604 3.604 0 00-1.605-4.584"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M142.136 116.083c.135.161.222.358.249.566.415 2.111-.437 4.245-1.267 6.235a2.716 2.716 0 00-.648-2.186 5.605 5.605 0 00-1.885-1.373 1.183 1.183 0 01-.377-.256.869.869 0 01-.135-.52 2.603 2.603 0 011.342-2.39c.625-.362 2.118-.686 2.721-.076z",
    fill: "#484848"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M230.321 193.942a131.645 131.645 0 0114.807-7.026l-2.329 23.01c-1.079 10.404-2.194 20.959-6.492 30.489-4.297 9.53-12.455 17.906-22.739 19.7-20.778 3.634-16.254-18.365-12.364-29.953a66.7 66.7 0 0129.117-36.22z",
    fill: "rgb(56 120 244 )"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M162.354 196.559c-.036-5.468.271-10.932.92-16.361l19.06 13.104c8.602 5.918 17.34 11.98 23.628 20.356 6.288 8.376 9.718 19.519 6.356 29.403-6.786 19.965-23.923 5.436-32.216-3.543a66.759 66.759 0 01-17.748-42.959z",
    fill: "rgb(56 120 244 )"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M224.962 202.364a131.632 131.632 0 0114.785-7.057l-2.33 23.01c-1.055 10.389-2.164 20.982-6.469 30.489-4.305 9.508-12.455 17.906-22.761 19.708-20.778 3.627-16.255-18.366-12.372-29.961a66.755 66.755 0 0129.147-36.189z",
    fill: "url(#prefix__paint3_linear_15788_47143)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M162.354 196.559c-.036-5.468.271-10.932.92-16.361l19.06 13.104c8.602 5.918 17.34 11.98 23.628 20.356 6.288 8.376 9.718 19.519 6.356 29.403-6.786 19.965-23.923 5.436-32.216-3.543a66.759 66.759 0 01-17.748-42.959z",
    fill: "url(#prefix__paint4_linear_15788_47143)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M172.148 213.454c-.039-5.464.266-10.926.912-16.352l19.06 13.103c8.602 5.911 17.34 11.972 23.635 20.319 6.296 8.346 9.719 19.526 6.356 29.403-6.785 19.972-23.922 5.436-32.223-3.543a66.673 66.673 0 01-17.74-42.93z",
    fill: "url(#prefix__paint5_linear_15788_47143)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M72.258 216.515c3.996-10.781 10.14-20.62 14.996-31.039a119.213 119.213 0 0115.87 81.862c-.678 3.958-1.575 7.939-3.498 11.453-2.82 5.164-11.799 13.065-18.456 11.203-5.934-1.666-9.357-15.674-10.925-21.367a85.647 85.647 0 012.013-52.112z",
    fill: "rgb(56 120 244 )"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M72.606 216.862c3.996-10.781 10.148-20.613 15.003-31.039a119.251 119.251 0 0115.871 81.869c-.679 3.951-1.584 7.932-3.506 11.453-2.82 5.157-11.8 13.065-18.45 11.196-5.94-1.667-9.363-15.667-10.931-21.367a85.647 85.647 0 012.013-52.112z",
    fill: "url(#prefix__paint6_linear_15788_47143)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M79.934 232.431c2.066-5.594 5.277-10.691 7.773-16.104a61.823 61.823 0 018.233 42.454 18.682 18.682 0 01-1.817 5.941c-1.463 2.677-6.115 6.785-9.568 5.805-3.083-.859-4.855-8.127-5.67-11.075a44.407 44.407 0 011.049-27.021z",
    fill: "url(#prefix__paint7_linear_15788_47143)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M34.496 278.021c.754-8.972 3.016-18.094.754-26.84-2.903-11.558-13.285-20.891-13.375-32.819 0-5.926 2.593-11.55 5.79-16.541a11.518 11.518 0 012.948-3.393c2.45-1.681 5.903-1.327 8.399.279 2.495 1.606 4.14 4.268 5.232 7.034 3.77 9.643 1.553 20.952 5.806 30.414 4.44 9.877 15.026 15.705 20.273 25.182a27.697 27.697 0 01-1.357 28.476c-4.976 7.245-15.833 13.42-24.963 12.018-9.59-1.478-10.156-16.029-9.507-23.81z",
    fill: "rgb(56 120 244 )"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M34.496 278.021c.754-8.972 3.016-18.094.754-26.84-2.903-11.558-13.285-20.891-13.375-32.819 0-5.926 2.593-11.55 5.79-16.541a11.518 11.518 0 012.948-3.393c2.45-1.681 5.903-1.327 8.399.279 2.495 1.606 4.14 4.268 5.232 7.034 3.77 9.643 1.553 20.952 5.806 30.414 4.44 9.877 15.026 15.705 20.273 25.182a27.697 27.697 0 01-1.357 28.476c-4.976 7.245-15.833 13.42-24.963 12.018-9.59-1.478-10.156-16.029-9.507-23.81z",
    fill: "url(#prefix__paint8_linear_15788_47143)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M44.477 260.515c-3.158-13.103-13.05-25.053-11.12-38.39.286-2.021 1.236-4.366 3.25-4.69 2.676-.437 4.221 2.873 4.885 5.504 1.138 4.524 2.443 9.047 4.735 13.051 4.161 7.335 11.256 12.56 15.976 19.542 6.355 9.401 8.459 23.1 3.49 33.587-1.998 4.215-6.031 8.347-11.135 7.087-5.278-1.319-6.582-7.298-7.397-11.927-1.38-7.863-.799-15.968-2.684-23.764z",
    fill: "url(#prefix__paint9_linear_15788_47143)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M301.674 208.425a131.45 131.45 0 0114.785-7.056l-2.33 23.01c-1.056 10.389-2.164 20.982-6.469 30.489-4.305 9.507-12.455 17.906-22.738 19.7-20.779 3.634-16.255-18.366-12.373-29.954a66.761 66.761 0 0129.125-36.189z",
    fill: "rgb(56 120 244 )"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M296.858 220.33a117.442 117.442 0 0113.232-6.31l-2.089 20.597c-.942 9.296-1.937 18.781-5.79 27.293-3.853 8.512-11.151 16.028-20.356 17.634-18.6 3.25-14.559-16.435-11.076-26.817a59.74 59.74 0 0126.079-32.397z",
    fill: "url(#prefix__paint10_linear_15788_47143)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M293.111 273.324c3.43-9.921 8.09-20.582 17.567-25.106 4.056-1.93 8.602-2.518 13.073-2.902 10.101-.86 20.258-.83 30.353.09-4.727 6.966-9.56 14.046-16.142 19.293-4.832 3.853-10.464 6.597-15.35 10.382-4.682 3.626-8.723 8.233-14.098 10.721-3.295 1.508-13.767 4.478-17.077 2.088-4.199-3.038.204-10.306 1.674-14.566z",
    fill: "rgb(56 120 244 )"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M293.111 273.324c3.43-9.921 8.09-20.582 17.567-25.106 4.056-1.93 8.602-2.518 13.073-2.902 10.101-.86 20.258-.83 30.353.09-4.727 6.966-9.56 14.046-16.142 19.293-4.832 3.853-10.464 6.597-15.35 10.382-4.682 3.626-8.723 8.233-14.098 10.721-3.295 1.508-13.767 4.478-17.077 2.088-4.199-3.038.204-10.306 1.674-14.566z",
    fill: "url(#prefix__paint11_linear_15788_47143)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M329.814 248.022c3.645.179 7.276.584 10.871 1.214l-9.439 12.229c-4.26 5.519-8.625 11.136-14.415 15.011-5.79 3.875-13.383 5.76-19.844 3.159-13.065-5.278-2.744-16.157 3.551-21.359a44.551 44.551 0 0129.276-10.254z",
    fill: "url(#prefix__paint12_linear_15788_47143)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M45.05 246.658a334.553 334.553 0 004.524 18.72c2.035 7.539 4.41 15.184 9.047 21.495 8.014 11.007 21.819 16.488 35.344 17.996a466.634 466.634 0 01-1.244-28.649c-.09-6.59.242-10.97-4.69-15.637-5.42-5.142-12.665-8.934-19.692-11.309-1.892-.588-23.583-4.003-23.29-2.616z",
    fill: "rgb(56 120 244 )"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M60.084 259a265.938 265.938 0 003.77 15.538c1.697 6.265 3.664 12.599 7.487 17.846 6.65 9.13 17.061 10.804 28.287 12.063-.588-7.901.121-12.945 0-20.869-.075-5.474.204-9.115-3.89-12.983-4.523-4.267-10.51-7.419-16.353-9.379-1.553-.528-19.542-3.362-19.3-2.216z",
    fill: "url(#prefix__paint13_linear_15788_47143)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M100.449 242.194c1.961-2.835 4.358-5.39 5.874-8.474 3.272-6.665 1.997-14.822 5.081-21.57.618-1.372 1.508-2.752 2.933-3.272 2.194-.807 4.584.807 5.865 2.752 4.381 6.634.717 15.418.996 23.372.15 4.365 1.508 8.587 2.261 12.884.37 2.104.573 4.321-.15 6.334a13.764 13.764 0 01-2.571 4.003c-5.866 7.087-14.076 11.784-22.34 4.961-6.634-5.542-2.133-14.958 2.051-20.99z",
    fill: "rgb(56 120 244 )"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M188.538 238.153H90.934v63.61h97.604v-63.61zM301.343 250.02h-97.605v51.743h97.605V250.02z",
    fill: "#fff"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M244.194 211.758H146.59v90.593h97.604v-90.593z",
    fill: "#fff"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M169.178 211.66h-22.377v25.528h22.377V211.66z",
    fill: "rgb(56 120 244 )"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M169.178 211.66h-22.377v25.528h22.377V211.66z",
    fill: "url(#prefix__paint14_linear_15788_47143)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M113.056 238.153h-22.06v67.839h22.06v-67.839z",
    fill: "rgb(56 120 244 )"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M113.228 238.055H90.852v66.957h22.376v-66.957z",
    fill: "url(#prefix__paint15_linear_15788_47143)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M199.14 222.117a19.97 19.97 0 003.574.204h3.769a29.219 29.219 0 003.695-.121 45.7 45.7 0 00-.211 4.795v15.614c-.021 1.512.06 3.023.241 4.524h-6.492c.176-1.501.254-3.013.234-4.524v-15.192h-1.191a32.935 32.935 0 00-3.634.204l.015-5.504zM140.885 273.649c-2.677 0-3.363 0-4.471.12.069-1.194.279-2.376.626-3.521a15.334 15.334 0 014.297-6.672 41.682 41.682 0 015.278-3.958c2.563-1.727 3.189-2.503 3.189-3.875 0-1.373-1.282-2.383-3.189-2.383a3.373 3.373 0 00-3.099 1.508 5.337 5.337 0 00-.754 2.503l-6.257-.656c.452-2.593.987-3.905 2.178-5.277 1.697-1.991 4.411-3.069 7.894-3.069 4.019 0 7.087 1.342 8.572 3.77a6.36 6.36 0 01.988 3.483 6.915 6.915 0 01-2.737 5.541 40.535 40.535 0 01-4.32 3.19c-2.593 1.786-3.694 2.827-4.38 4.139h6.944a39.062 39.062 0 004.764-.204v5.572a54.137 54.137 0 00-5.089-.204l-10.434-.007zM269.888 279.318c.052.712.344 1.384.829 1.908a4.665 4.665 0 003.431 1.274c2.322 0 3.769-1.161 3.769-2.978a2.575 2.575 0 00-1.605-2.556 8.46 8.46 0 00-2.767-.392c-1.161 0-2.503.06-3.665.181v-5.119c1.047.118 2.099.176 3.152.173 2.835 0 4.23-.95 4.23-2.857 0-1.614-1.124-2.534-3.092-2.534-2.118 0-3.189.837-3.634 2.737l-6.438-.92a8.625 8.625 0 011.998-3.769c1.817-1.968 4.561-2.978 8.187-2.978 3.25 0 5.934.897 7.63 2.533a5.776 5.776 0 011.666 4.229c0 3.159-1.696 5.127-5.126 5.926a6.69 6.69 0 013.845 1.584 5.86 5.86 0 011.968 4.403 6.626 6.626 0 01-1.192 3.965 7.473 7.473 0 01-2.797 2.262 16.078 16.078 0 01-6.197 1.161c-2.684 0-5.361-.626-6.944-1.666a8.123 8.123 0 01-3.068-3.838 12.56 12.56 0 01-.506-1.583l6.326-1.146z",
    fill: "rgb(56 120 244 )"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M194.117 152.31l1.809 55.414s-5.013 2.564-4.893 3.77c.121 1.206 10.555.204 10.555.204l3.695-50.348h1.749l3.558 50.144s6.175 1.402 7.691.935c1.515-.468-2.677-4.433-2.677-4.433l2.503-54.781-23.99-.905z",
    fill: "#606161"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M194.117 152.31l1.809 55.414s-5.013 2.564-4.893 3.77c.121 1.206 10.555.204 10.555.204l3.695-50.348h1.749l3.558 50.144s6.175 1.402 7.691.935c1.515-.468-2.677-4.433-2.677-4.433l2.503-54.781-23.99-.905z",
    fill: "url(#prefix__paint16_linear_15788_47143)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M121.687 177.514l1.161 55.739s-5.013 2.563-4.893 3.732c.121 1.168 10.555.203 10.555.203l3.702-50.355h1.742l3.558 50.152s6.175 1.394 7.691.927c1.515-.467-2.677-4.426-2.677-4.426l2.503-54.781-23.342-1.191z",
    fill: "#606161"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M121.687 177.514l1.161 55.739s-5.013 2.563-4.893 3.732c.121 1.168 10.555.203 10.555.203l3.702-50.355h1.742l3.558 50.152s6.175 1.394 7.691.927c1.515-.467-2.677-4.426-2.677-4.426l2.503-54.781-23.342-1.191z",
    fill: "url(#prefix__paint17_linear_15788_47143)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M259.152 190.067l1.81 55.422s-5.014 2.564-4.893 3.732c.12 1.169 10.555.204 10.555.204l3.701-50.356h1.742l3.559 50.152s6.174 1.395 7.69.928c1.515-.468-2.677-4.426-2.677-4.426l2.526-54.796-24.013-.86z",
    fill: "#606161"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M259.152 190.067l1.81 55.422s-5.014 2.564-4.893 3.732c.12 1.169 10.555.204 10.555.204l3.701-50.356h1.742l3.559 50.152s6.174 1.395 7.69.928c1.515-.468-2.677-4.426-2.677-4.426l2.526-54.796-24.013-.86z",
    fill: "url(#prefix__paint18_linear_15788_47143)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M195.801 49.94C186.075 45.516 186 26.426 186 25.62v-1.26h9.522v2.489h-7.004c.189 4.176 1.35 17.634 8.346 20.816l-1.063 2.277z",
    fill: "rgb(56 120 244 )"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M195.801 49.94C186.075 45.516 186 26.426 186 25.62v-1.26h9.522v2.489h-7.004c.189 4.176 1.35 17.634 8.346 20.816l-1.063 2.277z",
    fill: "url(#prefix__paint19_linear_15788_47143)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M216.971 51.162l-1.026-2.262c7.019-3.189 8.663-17.039 9.002-21.359h-6.959v-2.48h9.575l-.045 1.289c-.037.83-.852 20.401-10.547 24.812z",
    fill: "url(#prefix__paint20_linear_15788_47143)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M216.971 51.162l-1.026-2.262c7.019-3.189 8.663-17.039 9.002-21.359h-6.959v-2.48h9.575l-.045 1.289c-.037.83-.852 20.401-10.547 24.812z",
    fill: "url(#prefix__paint21_linear_15788_47143)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M188.758 112.472c-1.862-9.673 0-27.398.203-28.001.717-1.802 3.19.528 5.233.173-1.719 6.484 1.787 26.448 2.488 27.429.198.328.472.605.799.806.317.133.658.203 1.003.204a20.31 20.31 0 005.149-.355c3.016-.58 5.104-.233 7.615 0a3.93 3.93 0 004.244-3.332 83.408 83.408 0 00.302-22.264l3.837-.083a2.46 2.46 0 011.35.234 2.029 2.029 0 01.754 1.568c.957 7.148.754 18.502-.611 25.574-1.915 9.997-3.498 12.937-3.121 23.198 0 .754.663 15.697 0 16.195-1.146.912-22.377 2.45-24.005-.875-.234-.475-.317-16.247-.355-16.722-.135-1.839-3.068-14.332-4.885-23.749z",
    fill: "rgb(56 120 244 )"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M193.689 77.836a.688.688 0 01.37 0 .624.624 0 01.294.31c.272.72.385 1.492.331 2.261.089.8.346 1.57.754 2.262.86 1.968-1.236 2.262-3.015 2.164-3.944-.294-1.358-6.356 1.266-6.997z",
    fill: "url(#prefix__paint22_linear_15788_47143)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M216.094 85.316a1.808 1.808 0 00.754 1.967 3.987 3.987 0 002.164.566 2.556 2.556 0 001.922-.543 2.705 2.705 0 00.483-2.224c-.106-1.026-.498-4.878-2.39-3.483-.611.452-.709 1.507-1.305 2.103-.595.596-1.357.807-1.628 1.614z",
    fill: "url(#prefix__paint23_linear_15788_47143)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M219.641 69.445h-25.332v15.079h25.332V69.445z",
    fill: "#606161"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M219.641 69.445h-25.332v15.079h25.332V69.445z",
    fill: "url(#prefix__paint24_linear_15788_47143)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M192.972 23.063h27.662v19.798A13.833 13.833 0 01206.8 56.696a13.833 13.833 0 01-13.835-13.835V23.063h.007z",
    fill: "rgb(56 120 244 )"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M192.972 23.063h27.662v19.798A13.833 13.833 0 01206.8 56.696a13.833 13.833 0 01-13.835-13.835V23.063h.007z",
    fill: "url(#prefix__paint25_linear_15788_47143)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M211.943 55.158h-10.314v3.476h10.314v-3.476z",
    fill: "rgb(56 120 244 )"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.26,
    d: "M211.943 55.158h-10.314v2.616h10.314v-2.616z",
    fill: "url(#prefix__paint26_linear_15788_47143)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M208.374 57.684h-3.808v5.88h3.808v-5.88z",
    fill: "rgb(56 120 244 )"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M211.775 63.315h-10.517v3.061h10.517v-3.06z",
    fill: "rgb(56 120 244 )"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.26,
    d: "M211.775 63.315h-10.517v3.061h10.517v-3.06z",
    fill: "url(#prefix__paint27_linear_15788_47143)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M215.168 68.186v.867a1.634 1.634 0 01-.053.4h-17.484a2.235 2.235 0 01-.045-.4v-.867a1.89 1.89 0 01.549-1.338 1.888 1.888 0 011.336-.554h13.789a1.887 1.887 0 011.908 1.892z",
    fill: "rgb(56 120 244 )"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M212.2 103.802c.656 1.101 1.327 2.322 1.093 3.581-.407 2.194-3.287 3.114-4.018 5.225-.445 1.282-.053 2.903-.988 3.883-.935.98-2.955.512-3.875-.656-.92-1.169-1.176-2.707-1.666-4.109-.566-1.606-1.448-3.069-2.127-4.629a10.41 10.41 0 01-.98-4.984 5.493 5.493 0 012.503-4.26c1.508-.86 4.524-1.183 6.032-.24 1.809 1.077 3.031 4.447 4.026 6.189z",
    fill: "url(#prefix__paint28_linear_15788_47143)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M208.663 93.45a3.77 3.77 0 01-.4 1.878 1.412 1.412 0 011.229-.06 13.081 13.081 0 01-1.425 1.907 3.27 3.27 0 01-1.568 1.108c-.437.098-.89.045-1.327.143a3.472 3.472 0 00-1.636 1.161 4.43 4.43 0 00-1.237 2.028c-.286 1.44.792 2.79.988 4.245-.362.211-.829-.369-1.184-.158a.598.598 0 00-.17.21.59.59 0 00-.056.265 2.82 2.82 0 001.131 2.48l-.249 1.689a.898.898 0 01-.211.543c-.362.324-.897-.091-1.183-.483a40.377 40.377 0 01-3.77-6.37 5.926 5.926 0 01-.671-2.096 2.258 2.258 0 01.754-1.983c.152-.091.292-.203.414-.332.152-.244.23-.527.227-.814.324-2.624 2.714-3.634 4.93-4.358.792-.264 1.606-.452 2.39-.754.656-.188 2.956-1.583 3.024-.249z",
    fill: "#606161"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M208.663 93.45a3.77 3.77 0 01-.4 1.878 1.412 1.412 0 011.229-.06 13.081 13.081 0 01-1.425 1.907 3.27 3.27 0 01-1.568 1.108c-.437.098-.89.045-1.327.143a3.472 3.472 0 00-1.636 1.161 4.43 4.43 0 00-1.237 2.028c-.286 1.44.792 2.79.988 4.245-.362.211-.829-.369-1.184-.158a.598.598 0 00-.17.21.59.59 0 00-.056.265 2.82 2.82 0 001.131 2.48l-.249 1.689a.898.898 0 01-.211.543c-.362.324-.897-.091-1.183-.483a40.377 40.377 0 01-3.77-6.37 5.926 5.926 0 01-.671-2.096 2.258 2.258 0 01.754-1.983c.152-.091.292-.203.414-.332.152-.244.23-.527.227-.814.324-2.624 2.714-3.634 4.93-4.358.792-.264 1.606-.452 2.39-.754.656-.188 2.956-1.583 3.024-.249z",
    fill: "url(#prefix__paint29_linear_15788_47143)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.26,
    d: "M194.473 22.844v22.264s.467 4.524 2.91 6.876a19.084 19.084 0 005.36 3.498s-2.209-.814-2.442-10.72c-.234-9.908 0-21.797 0-21.797l-5.828-.12z",
    fill: "url(#prefix__paint30_linear_15788_47143)"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M215.449 72.265h-17.363v9.205h17.363v-9.205z",
    fill: "url(#prefix__paint31_linear_15788_47143)"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M199.336 113.271l2.752-.919s5.556 12.176 5.609 12.409c.053.234 2.918-12.643 2.918-12.643l2.156.58-4.78 19.354-8.655-18.781z",
    fill: "#fff"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M203.028 112.819l-.942-.46.286.618.656-.158z",
    fill: "url(#prefix__paint32_linear_15788_47143)"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M200.301 112.94l7.66 16.722 4.169-17.25-.701-.113-3.672 14.8-6.763-14.514-.693.355z",
    fill: "rgb(56 120 244 )"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M208.217 136.379a2.857 2.857 0 100-5.714 2.857 2.857 0 000 5.714z",
    fill: "#fff"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M112.732 139.131c-3.672-5.88-6.197-12.327-8.542-18.78-.55-1.508-.912-3.544.535-4.388a2.805 2.805 0 013.076.513 8.56 8.56 0 011.795 2.646 58.293 58.293 0 003.408 5.391l6.031 8.843a9.673 9.673 0 002.164 2.503c2.164 1.606 5.232 1.342 7.961.995a30.35 30.35 0 0114.589 1.365 21.476 21.476 0 015.278 3.084 69.415 69.415 0 017.72 6.649c1.824 1.817 3.657 4.268 2.759 6.627-.656 1.704-2.548 2.692-4.373 3.28-1.824.588-5.654 1.146-7.162 2.262a79.774 79.774 0 00-1.455 8.293l-.671 7.751c-.143 1.651-.362 3.46-1.644 4.591a6.827 6.827 0 01-3.302 1.304 40.106 40.106 0 01-15.493-.128c-1.161-.233-2.405-.588-3.084-1.508a4.446 4.446 0 01-.671-2.261c-.807-7.706-.249-15.524-1.606-23.161a17.616 17.616 0 00-1.575-5.172c-1.282-2.443-4.954-9.417-5.738-10.699z",
    fill: "rgb(56 120 244 )"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M143.726 160.95s0 19.527-2.828 21.111c0 0 4.592-.754 4.795-4.63.641-12.357 2.39-17.777 2.39-17.777l-4.357 1.296z",
    fill: "url(#prefix__paint33_linear_15788_47143)"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M143.725 160.95a47.883 47.883 0 00-5.873-.437 5.584 5.584 0 01-2.088-.279c-1.237-.52-1.863-1.87-2.39-3.099a10.446 10.446 0 01-1.146-4.523 2.896 2.896 0 00-.038-1.169c-.271-.792-1.236-1.025-2.006-1.364-2.646-1.154-3.656-4.343-4.131-7.193-.339-2.058-.52-4.32.588-6.084a20.534 20.534 0 002.45 8.233 7.574 7.574 0 002.42 2.887 3.45 3.45 0 003.597.219c.261-.148.477-.364.625-.626.113-.238.187-.492.219-.754a50.99 50.99 0 00.799-10.223 1.051 1.051 0 011.229.535c.208.447.293.942.249 1.433a21.301 21.301 0 01-1.938 8.602c-.693 1.508-1.56 3.242-.754 4.674a4.727 4.727 0 001.742 1.508 14.817 14.817 0 003.936 1.945c1.409.377 2.947.34 4.229 1.041 1.108.611 2.33 2.194 2.111 3.551-.271 1.749-2.488 1.304-3.83 1.123z",
    fill: "url(#prefix__paint34_linear_15788_47143)"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M137.21 156.653a3.58 3.58 0 100-7.163 3.582 3.582 0 000 7.163z",
    fill: "#fff"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M104.628 116.988a2.191 2.191 0 002.262-.61 2.265 2.265 0 00.422-2.262 4.506 4.506 0 01-.226-.679 2.908 2.908 0 01.332-1.508c.327-.883.444-1.83.339-2.767a1.234 1.234 0 00-.188-.61 1.37 1.37 0 00-.634-.423 4.737 4.737 0 00-3.204-.135 3.417 3.417 0 00-2.217 2.118c-.55 1.908.996 6.115 3.114 6.876z",
    fill: "url(#prefix__paint35_linear_15788_47143)"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M142.216 127.981a5.44 5.44 0 01-.754 3.596c-.595.792-3.702 1.508-4.523 2.096-.822.588-.619 4.237-1.003 5.081-.264.581-1.041 2.617-2.39 2.571-.83-.037-2.812-1.575-3.378-2.148a3.23 3.23 0 01-.701-1.923 71.244 71.244 0 01-.385-13.571c.091-1.372.279-2.865 1.297-3.845a5.16 5.16 0 012.767-1.184c1.953-.324 5.753-.301 7.178 1.229 1.575 1.682 1.764 5.979 1.892 8.098z",
    fill: "url(#prefix__paint36_linear_15788_47143)"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M139.909 118.836a8.039 8.039 0 01-1.335.565c-1.839.754-3.332 2.405-5.224 2.94-.664.181-1.508.324-1.742 1.033a2.325 2.325 0 00-.083.912l.121 3.68a1.131 1.131 0 00-1.976.166 2.778 2.778 0 00.249 2.57 5.226 5.226 0 01-1.945.287 2.003 2.003 0 01-1.636-1.093 4.993 4.993 0 01-.226-1.968c0-1.108-.256-2.202-.294-3.31a10.802 10.802 0 014.222-8.745 13.814 13.814 0 018.723-2.602 3.234 3.234 0 012.118.581 2.343 2.343 0 01.754 1.945 5.731 5.731 0 01-1.726 3.039z",
    fill: "#484848"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M282.901 155.1c1.47 3.136 1.508 6.732 1.508 10.193v16.345c0 3.37 0 6.786-.875 10.05a3.017 3.017 0 01-1.025 1.825 3.168 3.168 0 01-1.839.384 197.824 197.824 0 01-16.097-.528c-1.463-.113-3.016-.279-4.132-1.251-1.115-.973-1.507-2.775-1.726-4.358-.52-3.807 1.138-9.959.897-13.797-.415-6.559-2.36-11.211 1.025-16.843a13.241 13.241 0 012.398-3.016c5.157-4.727 16.368-6.476 19.866.996z",
    fill: "rgb(56 120 244 )"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M267.809 150.697l-3.754 12.477.814.234 1.749-2.563 2.269-7.638-1.078-2.51z",
    fill: "#fff"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M268.172 151.142l-3.664 12.304.362-.038.527-.874 3.107-10.495-.332-.897z",
    fill: "rgb(56 120 244 )"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M263.698 173.315c1.511 0 2.737-1.539 2.737-3.438 0-1.899-1.226-3.438-2.737-3.438-1.512 0-2.737 1.539-2.737 3.438 0 1.899 1.225 3.438 2.737 3.438z",
    fill: "#fff"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M281.996 157.347s3.264 3.377 1.636 10.487c-1.629 7.109-8.294 15.734-11.076 14.573-2.782-1.161-13.691-15.832-13.691-15.832l-.174-3.845 13.051 7.697s4.199-12.379 6.559-13.427a3.31 3.31 0 013.695.347z",
    fill: "url(#prefix__paint37_linear_15788_47143)"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M256.015 155.801a26.548 26.548 0 00-.264 8.353c.01.283.126.553.324.754.167.107.36.167.558.174.347.06.702.06 1.048 0a2.265 2.265 0 001.463-1.508 6.694 6.694 0 00.309-2.051l.038-1.953a12.54 12.54 0 00-.181-3.015c-.513-2.096-2.707-3.83-3.295-.754z",
    fill: "url(#prefix__paint38_linear_15788_47143)"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M260.585 155.545c-.339-.641-.874-1.38-1.591-1.267a1.505 1.505 0 00-.957.754 6.114 6.114 0 00-.566 4.523 16.564 16.564 0 001.795 4.275 4.205 4.205 0 001.04 1.41c.448.317.965.524 1.508.603a2.138 2.138 0 001.621-.166 1.923 1.923 0 00.679-1.553c.098-3.144-2.066-5.865-3.529-8.579z",
    fill: "url(#prefix__paint39_linear_15788_47143)"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M264.022 144.831a8.896 8.896 0 000 2.45 3.017 3.017 0 001.267 2.036c.829.513 2.051.528 2.526 1.387.354.649.113 1.553.61 2.096.402.328.916.488 1.433.445 1.206.045 2.518.068 3.483-.664 1.199-.912 1.395-2.608 1.508-4.116l.452-7.117a6.064 6.064 0 00-.482-3.483 5.028 5.028 0 00-1.727-1.576 6.93 6.93 0 00-3.596-1.244c-1.749 0-4.056 1.267-4.757 2.948a9.792 9.792 0 00-.34 2.82l-.377 4.018z",
    fill: "url(#prefix__paint40_linear_15788_47143)"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M268.45 132.617c-1.244.196-2.601-.708-3.724-.135a2.542 2.542 0 00-1.101 2.427c-.006.297.072.59.226.845.168.2.387.351.634.437a8.673 8.673 0 004.885.301 2.075 2.075 0 011.003 0c.25.103.472.264.648.468a5.423 5.423 0 011.712 2.382c.294 1.109-.121 2.345.347 3.386.372-.272.683-.619.912-1.018a2.39 2.39 0 01-.649 3.015 4.633 4.633 0 011.719 1.719 12.347 12.347 0 002.775-3.015c.356-.439.644-.93.852-1.455.475-1.425-.279-2.948-1.048-4.238-.98-1.673-2.104-3.4-3.845-4.267a5.383 5.383 0 00-4.365-.151 5.126 5.126 0 01-.981-.701z",
    fill: "#D8D8D8"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M141.771 152.695a1.504 1.504 0 00-.754-.249.623.623 0 00-.61.392 1.34 1.34 0 01-.098.384.552.552 0 01-.347.189c-.949.107-1.905.135-2.858.083a2.572 2.572 0 00-2.36 1.327 2.194 2.194 0 000 1.47 4.53 4.53 0 003.499 2.804c1.553.235 3.135.195 4.674-.12a2.195 2.195 0 001.048-.339c.596-.46 2.503-1.704 1.81-1.991-2.82-1.153-2.375-3.016-4.004-3.95z",
    fill: "url(#prefix__paint41_linear_15788_47143)"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M136.412 149.777l-.573-.151a23.708 23.708 0 00-3.453-.648c-.965 0-5.436-1.508-5.858-3.921a71.164 71.164 0 01-.528-8.097l.475-.249.897-.445 1.116-.573s-.377 6.409.942 8.422c1.32 2.013 5.738 2.329 6.356 3.996.053.128.075.226.128.324l.498 1.342z",
    fill: "#fff"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M137.24 135.724l2.216 1.342s1.282 1.922.468 3.619c-.814 1.696-3.559 6.318-2.714 8.813l-.815.271-1.07-2.073s-.241-2.412 1.862-6.258c2.104-3.845.053-5.714.053-5.714z",
    fill: "#fff"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M137.158 135.708l-1.025.935 1.749.144a3.424 3.424 0 00-.724-1.079z",
    fill: "url(#prefix__paint42_linear_15788_47143)"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M128.49 135.693l.98 1.131-.543.091-.505.068.068-1.29z",
    fill: "url(#prefix__paint43_linear_15788_47143)"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M136.381 149.596c-.159-.136-1.32-1.576 1.048-6.544 2.201-4.614.625-6.786.61-6.786l.784.377c.068.091 1.508 1.689-.859 6.71-2.156 4.524-1.018 6.152-1.003 6.16l-.58.083z",
    fill: "rgb(56 120 244 )"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M136.804 149.626l-.392.151-.422.151c-.053-.098-.098-.227-.151-.302-.475-.754-1.44-1.018-2.707-1.387a11.799 11.799 0 01-4.795-2.337c-1.764-1.508-1.885-6.929-1.862-9.191l.897-.445c-.075 2.405.121 7.721 1.508 8.987a10.822 10.822 0 004.471 2.141 9.015 9.015 0 012.533 1.041c.419.296.739.711.92 1.191z",
    fill: "rgb(56 120 244 )"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M143.884 154.783l6.416-3.853-5.248-4.893-2.329 7.457 1.161 1.289z",
    fill: "url(#prefix__paint44_linear_15788_47143)"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M281.886 153.735s3.265 3.378 1.629 10.487c-1.636 7.11-8.294 15.735-11.068 14.574-2.775-1.161-10.631-12.938-10.631-12.938l2.006-3.619 7.811 4.524s4.192-12.349 6.521-13.397a3.305 3.305 0 013.732.369z",
    fill: "rgb(56 120 244 )"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M277.307 150.38l-2.186-1.221-10.254 14.249 1.629 1.862 10.811-14.89z",
    fill: "#fff"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M275.997 149.709l-10.548 14.34.468.58 10.781-14.626-.701-.294z",
    fill: "rgb(56 120 244 )"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint0_linear_15788_47143",
    x1: 256.735,
    y1: 169.975,
    x2: 272.907,
    y2: 173.737,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#010101",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#010101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint1_linear_15788_47143",
    x1: 318.421,
    y1: 208.727,
    x2: 289.515,
    y2: 271.198,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#010101",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#010101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint2_linear_15788_47143",
    x1: 336.958,
    y1: 233.049,
    x2: 290.802,
    y2: 315.914,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#010101",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#010101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint3_linear_15788_47143",
    x1: 223.5,
    y1: 232.039,
    x2: 419.538,
    y2: 222.253,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#010101",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#010101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint4_linear_15788_47143",
    x1: 187.34,
    y1: 197.335,
    x2: 190.604,
    y2: 287.777,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#010101",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#010101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint5_linear_15788_47143",
    x1: 196.56,
    y1: 198.542,
    x2: 199.825,
    y2: 288.984,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#010101",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#010101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint6_linear_15788_47143",
    x1: 78.388,
    y1: 219.486,
    x2: 115.098,
    y2: 336.617,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#010101",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#010101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint7_linear_15788_47143",
    x1: 67.381,
    y1: 221.107,
    x2: 170.527,
    y2: 346.283,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#010101",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#010101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint8_linear_15788_47143",
    x1: 27.997,
    y1: 243.212,
    x2: 159.928,
    y2: 315.009,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#010101",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#010101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint9_linear_15788_47143",
    x1: 17.298,
    y1: 246.545,
    x2: 181.634,
    y2: 305.284,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#010101",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#010101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint10_linear_15788_47143",
    x1: 282.066,
    y1: 240.747,
    x2: 370.533,
    y2: 293.892,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#010101",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#010101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint11_linear_15788_47143",
    x1: 321.994,
    y1: 254.393,
    x2: 321.293,
    y2: 324.321,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#010101",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#010101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint12_linear_15788_47143",
    x1: 312.019,
    y1: 256.068,
    x2: 347.104,
    y2: 324.749,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#010101",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#010101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint13_linear_15788_47143",
    x1: 54.852,
    y1: 274.403,
    x2: 193.697,
    y2: 310.554,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#010101",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#010101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint14_linear_15788_47143",
    x1: 157.989,
    y1: 253.149,
    x2: 157.989,
    y2: 198.602,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#fff",
    stopOpacity: 0.23
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint15_linear_15788_47143",
    x1: 101.904,
    y1: 275.903,
    x2: 103.766,
    y2: 217.624,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#fff",
    stopOpacity: 0.23
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint16_linear_15788_47143",
    x1: 204.25,
    y1: 195.435,
    x2: 212.875,
    y2: 141.589,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#010101",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#010101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint17_linear_15788_47143",
    x1: 131.458,
    y1: 221.009,
    x2: 140.083,
    y2: 167.155,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#010101",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#010101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint18_linear_15788_47143",
    x1: 269.285,
    y1: 233.2,
    x2: 277.91,
    y2: 179.354,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#010101",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#010101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint19_linear_15788_47143",
    x1: 181.228,
    y1: 37.29,
    x2: 196.148,
    y2: 37.056,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#fff",
    stopOpacity: 0.23
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint20_linear_15788_47143",
    x1: 218.29,
    y1: 35.669,
    x2: 280.414,
    y2: 73.78,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#fff",
    stopOpacity: 0.23
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint21_linear_15788_47143",
    x1: 215.945,
    y1: 38.111,
    x2: 227.563,
    y2: 38.111,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#fff",
    stopOpacity: 0.23
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint22_linear_15788_47143",
    x1: 190.396,
    y1: 81.332,
    x2: 195.617,
    y2: 81.332,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8A4621"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.271,
    stopColor: "#BE6F46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C5A28F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint23_linear_15788_47143",
    x1: 216.032,
    y1: 84.585,
    x2: 221.461,
    y2: 84.585,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8A4621"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.271,
    stopColor: "#BE6F46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C5A28F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint24_linear_15788_47143",
    x1: 205.422,
    y1: 73.019,
    x2: 210.435,
    y2: 85.836,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#010101",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#010101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint25_linear_15788_47143",
    x1: 192.972,
    y1: 39.876,
    x2: 220.634,
    y2: 39.876,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#fff",
    stopOpacity: 0.23
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint26_linear_15788_47143",
    x1: 206.703,
    y1: 54.05,
    x2: 206.974,
    y2: 62.23,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#010101",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#010101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint27_linear_15788_47143",
    x1: 206.445,
    y1: 62.102,
    x2: 206.618,
    y2: 69.098,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#010101",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#010101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint28_linear_15788_47143",
    x1: 199.618,
    y1: 107.038,
    x2: 213.288,
    y2: 107.038,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8A4621"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.271,
    stopColor: "#BE6F46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C5A28F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint29_linear_15788_47143",
    x1: 206.054,
    y1: 100.756,
    x2: 196.615,
    y2: 106.003,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#010101",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#010101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint30_linear_15788_47143",
    x1: 183.247,
    y1: 39.891,
    x2: 232.433,
    y2: 37.561,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#010101",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#010101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint31_linear_15788_47143",
    x1: 206.862,
    y1: 61.069,
    x2: 206.628,
    y2: 99.768,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#fff",
    stopOpacity: 0.23
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint32_linear_15788_47143",
    x1: 202.086,
    y1: 112.668,
    x2: 203.028,
    y2: 112.668,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#010101",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#010101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint33_linear_15788_47143",
    x1: 140.046,
    y1: 170.201,
    x2: 162.363,
    y2: 173.601,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#010101",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#010101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint34_linear_15788_47143",
    x1: 111.668,
    y1: 142.222,
    x2: 213.042,
    y2: 167.389,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#010101",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#010101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint35_linear_15788_47143",
    x1: 101.399,
    y1: 112.435,
    x2: 107.77,
    y2: 112.435,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8A4621"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.271,
    stopColor: "#BE6F46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C5A28F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint36_linear_15788_47143",
    x1: 128.915,
    y1: 129.914,
    x2: 142.216,
    y2: 129.914,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8A4621"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.271,
    stopColor: "#BE6F46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C5A28F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint37_linear_15788_47143",
    x1: 263.471,
    y1: 182.543,
    x2: 307.29,
    y2: 87.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#010101",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#010101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint38_linear_15788_47143",
    x1: 255.537,
    y1: 159.633,
    x2: 259.499,
    y2: 159.633,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8A4621"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.271,
    stopColor: "#BE6F46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C5A28F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint39_linear_15788_47143",
    x1: 257.266,
    y1: 160.103,
    x2: 264.091,
    y2: 160.103,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8A4621"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.271,
    stopColor: "#BE6F46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C5A28F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint40_linear_15788_47143",
    x1: 263.932,
    y1: 144.16,
    x2: 275.331,
    y2: 144.16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8A4621"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.271,
    stopColor: "#BE6F46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C5A28F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint41_linear_15788_47143",
    x1: 134.612,
    y1: 155.848,
    x2: 145.881,
    y2: 155.848,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8A4621"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.271,
    stopColor: "#BE6F46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C5A28F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint42_linear_15788_47143",
    x1: 136.133,
    y1: 136.251,
    x2: 137.882,
    y2: 136.251,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#010101",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#010101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint43_linear_15788_47143",
    x1: 127.932,
    y1: 135.422,
    x2: 129.485,
    y2: 137.699,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#010101",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#010101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint44_linear_15788_47143",
    x1: 141.72,
    y1: 147.04,
    x2: 160.018,
    y2: 166.854,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#010101",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#010101"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWinnere996E91C);
export default __webpack_public_path__ + "static/media/winner.e996e91c.ab26927e58db69c21a2d4f22217e85b7.svg";
export { ForwardRef as ReactComponent };